import React from 'react';
import { ArrowLeft, Shield, Save, Plus } from 'lucide-react';
import RippleButton from '../../../../common/RippleButton';
import type { PermissionsHeaderProps } from '../../../../../types/groupModulePermissions';

const PermissionsHeader: React.FC<PermissionsHeaderProps> = ({
  selectedGroup,
  hasChanges,
  onBack,
  onSave,
  mode = 'edit'
}) => {
  const isCreateMode = mode === 'create';
  const buttonText = isCreateMode ? 'Create' : 'Save Changes';
  const buttonIcon = isCreateMode ? Plus : Save;
  const ButtonIcon = buttonIcon;

  return (
    <div className="permissions-header">
      <div className="permissions-header-left">
        <div className="permissions-icon">
          <Shield size={24} />
        </div>
        <div className="permissions-title-section">
          <h1 className="permissions-title">Group Module Permissions</h1>
          {selectedGroup && (
            <div className="permissions-context">
              {selectedGroup.name} - {isCreateMode ? 'Create Group Module Permission' : 'Edit Group Module Permission'}
            </div>
          )}
        </div>
      </div>
      
      <div className="permissions-header-actions">
        <RippleButton
          className="btn-back-to-list circular-back-btn"
          onClick={onBack}
          variant="secondary"
        >
          <ArrowLeft size={16} />
        </RippleButton>
        
        
        <RippleButton
          className={`btn-save-changes ${hasChanges ? 'has-changes' : ''}`}
          onClick={onSave}
          variant="primary"
          disabled={!hasChanges && !isCreateMode}
        >
          <ButtonIcon size={16} />
          {buttonText}
        </RippleButton>
      </div>
    </div>
  );
};

export default PermissionsHeader;